<template>
  <div class="home">
    <div class="imagem"></div>
    <div>
      <!-- <Header :path="{name: 'vivo.consulta.home'}" /> -->
      <Header />
    </div>

    <div class="main-holder">
      <busca />
    </div>

    <section class="item-detalhado">
      <template v-if="loadingModelos">
        <div class="loading-modelo">
          <img src="@/assets/imgs/puff.svg" alt="Loading..." />
        </div>
      </template>
      <template v-if="!loadingModelos && cel">
        <div class="nome-do-aparelho">
          <span v-if="cel.prevenda">PRÉ-LANÇAMENTO</span>
          <h1>
            {{ cel.marca.nome }}
            <strong>{{ cel.modelo }}</strong>
          </h1>
        </div>

        <div class="conteudo-principal" v-if="!cel.prevenda">
          <div class="imagem-destaque">
            <celular-detalhado-imagem :imagem="cel.imagem" />
            <!-- <img v-if="!!cel.imagem" :src="cel.imagem" :key="cel.id" />
            <img v-else src="@/assets/vivo-consulta/imagens/generic_phone_teaser.png" />-->
          </div>
          <div class="planos" v-if="cel.tipo === 'smartphone'">
            <template v-if="true">
              <ul class="selecione-planos">
                <li v-for="(p, idx) in btnPlanos" :key="idx">
                  <input
                    type="radio"
                    name="select_planos"
                    v-model="planoSelect"
                    :id="`planos-${p.id}`"
                    :value="p.id"
                  />
                  <label :for="`planos-${p.id}`">{{ p.name }}</label>
                </li>
              </ul>
              <div class="busca-planos">
                <input
                  v-model="inputSearch"
                  type="text"
                  class="input-bp"
                  placeholder="Digite uma palavra chave para filtrar os planos"
                  :disabled="!oncePrePago"
                />
                <img src="@/assets/vivo-consulta/imagens/busca-planos.svg" alt="Busca" />
              </div>
            </template>
            <template v-else>
              <ul class="foco">
                <li>
                  <p>
                    R$
                    <strong>{{ cel.preco | convertMoeda }}</strong>
                  </p>
                  <h4>PREÇO</h4>
                </li>
              </ul>
            </template>
            <p class="selo-outlet" v-if="percOutlet > 0">Produto Outlet com {{ percOutletTexto }}% de desconto aplicado</p>
            <div class="bloco-parcelamento" v-if="parcelamentosDisponiveis.length > 0">
              <p class="aviso-pix" v-if="exibirAvisoPix">
                Os valores apresentados consideram o pagamento à vista no PIX. Escolha outra forma
                de pagamento abaixo para ver os demais valores.
              </p>
              <div class="filtro-parcelamento">
                <label for="parcelamento">Forma de pagamento</label>
                <select id="parcelamento" v-model.number="parcelaSelecionada">
                  <option v-for="opcao in parcelamentosDisponiveis" :key="opcao.qtde" :value="opcao.qtde">
                    {{ opcao.rotulo }}
                  </option>
                </select>
              </div>
            </div>
            <div class="lista" v-if="this.planoSelect !== 4">
              <nav>
                <div class="botoes">
                  <button
                    v-if="oncePrePago && this.planoSelect !== 4"
                    @click="handleChangeTab('sva')"
                    :class="listaAtiva == 'sva' ? 'ativo' : ''"
                  >
                    Com SVAs
                  </button>
                  <button
                    v-if="oncePrePago && this.planoSelect !== 4"
                    @click="handleChangeTab('sem')"
                    :class="listaAtiva == 'sem' ? 'ativo' : ''"
                  >
                    Sem SVAs
                  </button>
                </div>
                <div class="labels" :class="{ 'com-outlet': percOutlet > 0 }">
                  <span>Preço</span>
                  <span class="renova">Renova</span>
                  <span class="outlet" v-if="percOutlet > 0">Outlet</span>
                </div>
              </nav>

              <div class="list-planos" v-if="listaAtiva == 'sva' && this.planoSelect !== 4">
                <p class="title" v-if="oncePrePago">MENSAL</p>
                <ul
                  v-if="!!getPlanos.sva && getPlanos.sva.mensal && getPlanos.sva.mensal.length > 0 && this.planoSelect !== 4"
                >
                  <li v-for="(p, indice) in getPlanos.sva.mensal" :key="indice">
                    <p class="descricao">
                      {{ montaNomePlano(p) }}
                    </p>
                    <div class="valores" :class="{ 'com-outlet': percOutlet > 0 }">
                      <p class="preco">R$ {{ valorPreco(p) | convertMoeda }}</p>
                      <p class="renova">R$ {{ valorRenova(p) | convertMoeda }}</p>
                      <p class="outlet" v-if="percOutlet > 0">R$ {{ valorPlano(p) | convertMoeda }}</p>
                    </div>
                  </li>
                </ul>
                <ul v-else>
                  <li v-if="oncePrePago">
                    <span>Nenhum plano encontrado.</span>
                  </li>
                </ul>
                <p class="title" v-if="oncePrePago && this.planoSelect !== 4">ANUAL</p>
                <ul v-if="this.planoSelect === 4">
                  <li v-for="(p, indice) in getPlanos.sva.anual" :key="indice">
                    <p class="descricao">{{ p.plano.nome }}</p>
                    <div class="valores" :class="{ 'com-outlet': percOutlet > 0 }">
                      <p class="preco">R$ {{ valorPreco(p) | convertMoeda }}</p>
                      <p class="renova">R$ {{ valorRenova(p) | convertMoeda }}</p>
                      <p class="outlet" v-if="percOutlet > 0">R$ {{ valorPlano(p) | convertMoeda }}</p>
                    </div>
                  </li>
                </ul>
                <ul v-else-if="!!getPlanos.sva && getPlanos.sva.anual && getPlanos.sva.anual.length > 0 && this.planoSelect !== 4">
                  <li v-for="(p, indice) in getPlanos.sva.anual" :key="indice">
                    <p class="descricao">
                      {{ montaNomePlano(p) }}
                    </p>
                    <div class="valores" :class="{ 'com-outlet': percOutlet > 0 }">
                      <p class="preco">R$ {{ valorPreco(p) | convertMoeda }}</p>
                      <p class="renova">R$ {{ valorRenova(p) | convertMoeda }}</p>
                      <p class="outlet" v-if="percOutlet > 0">R$ {{ valorPlano(p) | convertMoeda }}</p>
                    </div>
                  </li>
                </ul>
                <ul v-else>
                  <li v-if="oncePrePago">
                    <span>Nenhum plano encontrado.</span>
                  </li>
                </ul>
              </div>

              <div class="list-planos" v-else>
                <p class="title">MENSAL</p>
                <ul v-if="getPlanos.sem.mensal && getPlanos.sem.mensal.length > 0 && this.planoSelect !== 4">
                  <li v-for="(p, indice) in getPlanos.sem.mensal" :key="indice">
                    <p class="descricao">
                      {{ montaNomePlano(p) }}
                    </p>
                    <div class="valores" :class="{ 'com-outlet': percOutlet > 0 }">
                      <p class="preco">R$ {{ valorPreco(p) | convertMoeda }}</p>
                      <p class="renova">R$ {{ valorRenova(p) | convertMoeda }}</p>
                      <p class="outlet" v-if="percOutlet > 0">R$ {{ valorPlano(p) | convertMoeda }}</p>
                    </div>
                  </li>
                </ul>
                <ul v-else>
                  <li>
                    <span>Nenhum plano encontrado.</span>
                  </li>
                </ul>
                <p class="title">ANUAL</p>
                <ul v-if="getPlanos.sem.anual && getPlanos.sem.anual.length > 0 && this.planoSelect !== 4">
                  <li v-for="(p, indice) in getPlanos.sem.anual" :key="indice">
                    <p class="descricao">
                      {{ montaNomePlano(p) }}
                    </p>
                    <div class="valores" :class="{ 'com-outlet': percOutlet > 0 }">
                      <p class="preco">R$ {{ valorPreco(p) | convertMoeda }}</p>
                      <p class="renova">R$ {{ valorRenova(p) | convertMoeda }}</p>
                      <p class="outlet" v-if="percOutlet > 0">R$ {{ valorPlano(p) | convertMoeda }}</p>
                    </div>
                  </li>
                </ul>
                <ul v-else>
                  <li>
                    <span>Nenhum plano encontrado.</span>
                  </li>
                </ul>
              </div>
            </div>
            <div class="lista" v-else>
              <nav style="justify-content: end;">
                <div class="labels-vitrine" v-if="planoVitrine !== null">
                  <span style="display: flex; justify-content: end; color: #4E4E4E;">Preço</span>
                </div>
              </nav>
              <div class="list-planos">
                <ul v-if="planoVitrine !== null">
                  <li>
                    <p class="descricao">VITRINE</p>
                    <div style="width: 200px">
                      <p class="preco-vitrine">R$ {{ valorVitrine() | convertMoeda }}</p>
                    </div>
                  </li>
                  <li style="margin-top: 4px; color: #4E4E4E; margin-left: 18px;list-style-type:square;">
                    <span>
                      <em>Por enquanto, tabela disponível apenas para Lojas Próprias;</em><br>
                    </span>
                  </li>
                  <li style="margin-top: 4px; color: #4E4E4E; margin-left: 18px;list-style-type:square;">
                    <span>
                      <em>Produtos origem Apple, devem ser faturados apenas para colaboradores Vivo;</em><br>
                    </span>
                  </li>
                  <li style="margin-top: 4px; color: #4E4E4E; margin-left: 18px;list-style-type:square;">
                    <span>
                      <em>Produtos origem Android, podem ser faturados para qualquer cliente;</em><br>
                    </span>
                  </li>
                  <li style="margin-top: 4px; color: #4E4E4E; margin-left: 18px;list-style-type:square;">
                    <span>
                      <em>Consulte a lista de IMEIs disponíveis, no Conteúdos Vivo.</em><br>
                    </span>
                  </li>
                </ul>
                <ul v-else>
                  <li>
                    <span>Nenhum plano encontrado.</span>
                  </li>
                </ul>
              </div>

            </div>
          </div>
          <div class="acessorios" v-else>
            <div class="bloco-parcelamento" v-if="parcelamentosDisponiveis.length > 0">
              <p class="aviso-pix" v-if="exibirAvisoPix">
                Os valores apresentados consideram o pagamento à vista no PIX. Escolha outra forma
                de pagamento abaixo para ver os demais valores.
              </p>
              <div class="filtro-parcelamento">
                <label for="parcelamentoAcessorio">Forma de pagamento</label>
                <select id="parcelamentoAcessorio" v-model.number="parcelaSelecionada">
                  <option v-for="opcao in parcelamentosDisponiveis" :key="opcao.qtde" :value="opcao.qtde">
                    {{ opcao.rotulo }}
                  </option>
                </select>
              </div>
            </div>
            <div class="preco">
              <p>
                <span>R$</span>
                <strong>{{ valorAcessorio() | convertMoeda }}</strong>
              </p>
            </div>
            <p class="selo-outlet" v-if="percOutlet > 0">Produto Outlet com {{ percOutletTexto }}% de desconto aplicado</p>
          </div>
        </div>

        <div class="conteudo-principal" v-else>
          <div class="imagem-destaque">
            <img src="@/assets/vivo-consulta/imagens/generic_phone_teaser.png" />
            <span>
              <img src="@/assets/vivo-consulta/icones/icone-alerta.svg" class="alerta" alt />
              <p>Imagem meramente ilustrativa</p>
            </span>
          </div>
          <div class="planos">
            <div class="head">
              <h3>Cadastro de Pré Venda</h3>
              <div class="pdv">
                <div class="linha-inputs">
                  <UiSelect
                    :ativo="true"
                    placeholder="PDV"
                    :destaque="true"
                    icone="icone-local-roxo.svg"
                    :options="pdvs"
                    style="flex: 0.7"
                  />
                  <UiSelect
                    :ativo="true"
                    placeholder="UF"
                    :options="ufs"
                    :destaque="true"
                    style="flex: 0.25"
                  />
                </div>
                <h6>
                  <strong>Status:</strong>
                  {{ status }}
                </h6>
              </div>
            </div>
            <div class="cadastro">
              <div class="linha-inputs linha">
                <UiInput
                  label="Nome Completo do Cliente"
                  placeholder="Nome Completo"
                  :tamanhoMax="50"
                  style="flex: 0.69"
                />
                <UiInput
                  label="CPF"
                  placeholder="000.000.000-00"
                  mascara="###.###.###-##"
                  style="flex: 0.29"
                />
              </div>

              <div class="linha-inputs linha">
                <UiInput
                  label="Telefone"
                  placeholder="Telefone"
                  :mascara="['(##)####-####', '(##)#####-####']"
                  style="flex: 0.49"
                />
                <UiInput
                  label="E-mail"
                  placeholder="email@email.com.br"
                  :tamanhoMax="40"
                  style="flex: 0.49"
                />
              </div>

              <div class="linha-inputs linha">
                <UiInput
                  label="CEP"
                  placeholder="00.000-000"
                  mascara="##.###-###"
                  style="flex: 0.42"
                />
                <UiSelect :ativo="true" placeholder="UF" :options="ufs" style="flex: 0.12" />
                <UiInput label="Cidade" placeholder="Cidade" :tamanhoMax="30" style="flex: 0.42" />
              </div>

              <div class="linha-inputs linha">
                <UiInput
                  label="Endereço"
                  placeholder="Endereço com número e complemento"
                  :tamanhoMax="50"
                  style="flex: 0.59"
                />
                <UiInput
                  label="Bairro"
                  placeholder="Nome do Bairro"
                  :tamanhoMax="30"
                  style="flex: 0.39"
                />
              </div>

              <div class="linha-inputs linha">
                <UiTextarea
                  label="Observações"
                  placeholder="Insira alguma observação sobre a reserva..."
                  :tamanhoMax="120"
                  style="flex: 0.69"
                  :altura="'60px'"
                />
                <button type="button" :disabled="estadoBotao">SALVAR</button>
              </div>
            </div>
          </div>
        </div>

        <div class="ficha-tecnica" v-if="cel.esp.length > 0">
          <h2>FICHA TÉCNICA:</h2>
          <ul>
            <li v-for="(esp, index) in cel.esp" :key="index">
              <p>
                <strong>{{ esp.tipo.nome }}:</strong>
                {{ esp.nome }}
              </p>
            </li>
            <li v-if="cel.sku">
              <p>
                <strong>SKU:</strong>
                {{ cel.sku }}
              </p>
            </li>
          </ul>
          <span></span>
        </div>

        <aparelho-similar
          :similares="similares"
          :loading="loadingSimilar"
          :key="!!loadingSimilar"
        />
      </template>
    </section>

    <div class="main-footer-holder">
      <div class="fale-conosco">
        <FaleConosco/>
      </div>

      <MainFooter />
    </div>
    <botao-voltar-topo />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Header from '@/components/layout/header/Header.vue';
import MainFooter from '@/components/layout/footer/MainFooter.vue';
import Busca from '@/components/vivo-consulta/header/Busca.vue';
import UiSelect from '@/components/vivo-consulta/ui/UiSelect.vue';
import UiInput from '@/components/vivo-consulta/ui/UiInput.vue';
import UiTextarea from '@/components/vivo-consulta/ui/UiTextarea.vue';
import AparelhoSimilar from '@/components/vivo-consulta/conteudo/AparelhoSimilar.vue';
import CelularDetalhadoImagem from '@/components/vivo-consulta/conteudo/CelularDetalhadoImagem.vue';
import BotaoVoltarTopo from '@/components/BotaoVoltarTopo.vue';
import { clone, includes } from 'lodash';
import axios from 'axios';
import FaleConosco from '@/components/layout/conteudo/FaleConosco.vue';

export default {
  name: 'CelularDetalhado',

  components: {
    Header,
    MainFooter,
    Busca,
    UiSelect,
    UiInput,
    UiTextarea,
    CelularDetalhadoImagem,
    AparelhoSimilar,
    BotaoVoltarTopo,
    FaleConosco,
  },

  data() {
    return {
      btnPlanos: [
        { name: 'PRÉ PAGO', id: 2, column: 'pre' },
        { name: 'CONTROLE', id: 3, column: 'controle' },
        { name: 'PÓS / VIVO TOTAL', id: 1, column: 'pos' },
        { name: 'VITRINE', id: 4, column: 'vitrine' },
      ],
      planoSelect: null,
      inputSearch: '',
      estadoBotao: false,
      prevenda: false,
      pdvs: ['PDV1', 'PDV2', 'PDV3'],
      ufs: ['MS', 'MT', 'SP', 'RJ', 'TO'],
      status: 'Pré Lançamento Cadastrado',
      listaAtiva: 'sva',
      numPages: 0,
      pageCurrent: 1,
      numCelularesMin: 0,
      numCelularesMax: 4,
      planoVitrine: null,
      /**
       * Forma de pagamento escolhida no seletor, na convenção da tabela de
       * preço nova: 0 = PIX, 1 = à vista, acima de 1 = crédito parcelado.
       * Começa no PIX, que é o valor mostrado por padrão.
       */
      parcelaSelecionada: 0,
    };
  },
  computed: {
    ...mapGetters({
      tabela: 'vcTabela/tabela',
      renova: 'vcTabela/renova',
      cel: 'vcModelo/modelo',
      planos: 'vcPlano/planos',
      similares: 'vcModelo/similares',
      loadingModelos: 'vcModelo/loading',
      loadingSimilar: 'vcModelo/loadingSimilar',
      ufId: 'vcUser/ufId',
    }),
    getPlanos() {
      if (this.planoSelect) {
        const { column } = this.btnPlanos.find(p => p.id === this.planoSelect);
        const data = this.planos(column);
        if (this.planoSelect !== 2 && this.planoSelect !== 4 && this.inputSearch && this.inputSearch !== '') {
          const key = this.listaAtiva;
          /**
           * Planos Anuais
           */
          const [anual] =
            data[key].anual !== undefined
              ? [data[key]].map(p =>
                  p.anual.filter(a =>
                    includes(a.plano.nome.toLowerCase(), this.inputSearch.toLowerCase()),
                  ),
                )
              : [];
          /**
           * Planos Mensais
           */
          const [mensal] =
            data[key].mensal !== undefined
              ? [data[key]].map(p =>
                  p.mensal.filter(a =>
                    includes(a.plano.nome.toLowerCase(), this.inputSearch.toLowerCase()),
                  ),
                )
              : [];
          const array = clone(data, true);
          array[key] = { anual, mensal };
          console.log(array);
          return array;
        } else return data;
      }
    },
    oncePrePago() {
      let show = true;
      if (this.planoSelect === 2 || this.planoSelect === 4) {
        this.listaAtiva = 'sva';
        show = false;
      } else {
        show = true;
      }
      return show;
    },
    percOutlet() {
      let maior = 0;

      const considerar = lista => {
        (lista || []).forEach(p => {
          const formas = (p.plano && p.plano.formasPagamento) || [];
          formas.forEach(f => {
            const perc = Number(f.perc_desconto_outlet);
            if (perc > maior) maior = perc;
          });
        });
      };

      ['pos', 'pre', 'controle'].forEach(portfolio => {
        const grupos = this.planos(portfolio) || {};
        ['sva', 'sem'].forEach(chave => {
          const grupo = grupos[chave] || {};
          considerar(grupo.mensal);
          considerar(grupo.anual);
        });
      });

      return maior;
    },
    percOutletTexto() {
      return String(Number(this.percOutlet.toFixed(2))).replace('.', ',');
    },
    getParcelamentoAcessorio(){
      const planosPre = this.planos('pre');
      const planosAcessorio = {};
      for (let chave in planosPre) {
        if(planosPre[chave].mensal != undefined){
          planosAcessorio[chave] = planosPre[chave].mensal[0]
        }
      }
      return planosAcessorio;
    },
    /**
     * Formas de pagamento que os planos em tela realmente possuem, em ordem
     * (PIX, à vista e depois as parceladas).
     */
    parcelamentosDisponiveis() {
      const parcelas = new Set();

      const coletar = lista => {
        (lista || []).forEach(p => {
          const formas = (p.plano && p.plano.formasPagamento) || [];
          formas.forEach(f => parcelas.add(Number(f.qtde_parcelas)));
        });
      };

      /**
       * Varre os três portfólios e não só a aba aberta. A aba inicial é PRÉ
       * PAGO e a maioria dos aparelhos não tem plano nela: olhando só para a
       * aba atual o seletor não aparecia no carregamento da tela.
       */
      ['pos', 'pre', 'controle'].forEach(portfolio => {
        const grupos = this.planos(portfolio) || {};
        ['sva', 'sem'].forEach(chave => {
          const grupo = grupos[chave] || {};
          coletar(grupo.mensal);
          coletar(grupo.anual);
        });
      });

      if (this.planoVitrine && Array.isArray(this.planoVitrine.parcelamentos)) {
        this.planoVitrine.parcelamentos.forEach(f => parcelas.add(Number(f.qtde_parcelas)));
      }

      return Array.from(parcelas)
        .sort((a, b) => a - b)
        .map(qtde => ({ qtde, rotulo: this.rotuloParcelamento(qtde) }));
    },
    exibirAvisoPix() {
      return this.parcelaSelecionada === 0;
    },
  },
  methods: {
    ...mapActions({
      getModelo: 'vcModelo/getModelo',
      setTitle: 'apiRoute/setTitle',
    }),
    proxima() {
      this.numPages = Math.ceil(this.similares.paginate.to / 4);
      if (this.numPages > this.pageCurrent) {
        this.numCelularesMax = this.numCelularesMax + 4;
        this.numCelularesMin = this.numCelularesMin + 4;
        this.pageCurrent = this.pageCurrent + 1;
      } else if (this.numPages == this.pageCurrent) {
        this.numCelularesMax = 4;
        this.numCelularesMin = 0;
        this.pageCurrent = 1;
      }
    },
    anterior() {
      this.numPages = Math.ceil(this.similares.paginate.to / 4);
      if (this.pageCurrent > 1) {
        this.numCelularesMax = this.numCelularesMax - 4;
        this.numCelularesMin = this.numCelularesMin - 4;
        this.pageCurrent = this.pageCurrent - 1;
      } else if (this.numPages == 1) {
        this.numCelularesMax = this.similares.paginate.to;
        this.numCelularesMin = 4 * (this.numPages - 1);
        this.pageCurrent = this.numPages;
      }
    },
    moveCarousel(direction) {
      // Find a more elegant way to express the :style. consider using props to make it truly generic
      if (direction === 1 && !this.atEndOfList) {
        this.currentOffset -= this.paginationFactor;
      } else if (direction === -1 && !this.atHeadOfList) {
        this.currentOffset += this.paginationFactor;
      }
    },
    handleChangeTab(tab) {
      this.listaAtiva = tab;
    },
    handleRedirectPage(tabela) {
      const { page, id } = this.$route.params;
      switch (page) {
        case 'smartphone':
          this.getModelo({
            tabela,
            renova: this.renova,
            modelo: +id,
            tipo: page,
          });
          var URL_TABELA_PRECO_VITRINE = `${process.env.VUE_APP_API_URL}/portal/${this.ufId}/tabela-preco/${id}`;
          fetch(URL_TABELA_PRECO_VITRINE, {
            method: "GET",
          })
            .then((response) => {
              response.json().then((res) => {
                if(res.length > 0){
                  this.planoVitrine = res[0];
                } else {
                  this.planoVitrine = this.ufId;
                }
              });
            })
            .catch((err) => {
              this.planoVitrine = err;
            });
          break;
        case 'acessorios':
          this.getModelo({
            tabela,
            renova: this.renova,
            modelo: id,
            tipo: page,
          });
          break;
        default:
          this.$router.push({ name: 'vivo.consulta.home' });
          break;
      }
    },
    rotuloParcelamento(qtde) {
      if (qtde === 0) return 'À vista no PIX';
      if (qtde === 1) return 'À vista (dinheiro, débito ou crédito)';
      return `${qtde}x no crédito`;
    },
    /**
     * Valor do plano na forma de pagamento escolhida. Cai no cp_valor antigo
     * enquanto o plano não tiver preço na tabela nova, para não sumir da tela.
     */
    valorPlano(p) {
      const formas = (p.plano && p.plano.formasPagamento) || [];
      const forma = formas.find(f => Number(f.qtde_parcelas) === this.parcelaSelecionada);

      return forma ? Number(forma.valor) : p.valor;
    },
    valorPreco(p) {
      return this.percOutlet > 0 ? 0 : this.valorPlano(p);
    },
    valorRenova(p) {
      return this.percOutlet > 0 ? 0 : p.descontoRenova;
    },
    /**
     * Acessório tem um preço só (não varia por plano), mas varia por forma de
     * pagamento. Pega o primeiro plano que tenha valores na tabela nova.
     */
    valorAcessorio() {
      const planos = Object.values(this.getParcelamentoAcessorio || {});

      for (const p of planos) {
        const formas = (p.plano && p.plano.formasPagamento) || [];
        const forma = formas.find(f => Number(f.qtde_parcelas) === this.parcelaSelecionada);

        if (forma) return Number(forma.valor);
      }

      return this.cel ? this.cel.preco : null;
    },
    valorVitrine() {
      if (!this.planoVitrine) return null;

      const formas = this.planoVitrine.parcelamentos || [];
      const forma = formas.find(f => Number(f.qtde_parcelas) === this.parcelaSelecionada);

      return forma ? Number(forma.valor) : this.planoVitrine.valor;
    },
    montaNomePlano(p) {
      if (p.plano.sap) {
        return `${p.plano.nome} - (${p.plano.sap})`;
      } else {
        return `${p.plano.nome}`;
      }
    },
  },
  beforeMount() {
    if (this.tabela) this.handleRedirectPage(this.tabela);
    this.$store.subscribe(mutation => {
      const { type, payload } = mutation;
      switch (type) {
        case 'vcTabela/TABELA_ADD':
          this.handleRedirectPage(payload.tabela);
      }
    });

    this.$set(this, 'planoSelect', 2);
  },
  watch: {
    /**
     * Nem toda importação tem o PIX (parcela 0) cadastrado. Sem isso o seletor
     * abria no PIX, a busca do valor não achava nada e a tela caía calada no
     * preço antigo, sem casar com a opção marcada.
     */
    parcelamentosDisponiveis(opcoes) {
      if (opcoes.length && !opcoes.some(o => o.qtde === this.parcelaSelecionada)) {
        this.parcelaSelecionada = opcoes[0].qtde;
      }
    },
    planoSelect(after) {
      if (after) {
        this.$set(this, 'inputSearch', '');
      }
    },
    $route: {
      handler: function(route) {
        this.handleRedirectPage(this.tabela);
      },
    },
    cel(after) {
      if (after) {
        this.setTitle({ title: `${after.modelo} | Vivo Consulta`, system: 2 });
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/estilo/sass/_formulas.scss';
@import '@/estilo/sass/_cores.scss';

.loading-modelo {
  width: 100%;
  min-height: 560px;
  background-color: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
}

.home {
  padding-bottom: 50px;
  position: relative;

  & .imagem {
    position: absolute;
    user-select: none;
    height: 335px;
    width: 100%;
    object-fit: cover;
    background: url('./../../assets/vivo-consulta/imagens/pattern-header-reto.jpg');
    background-repeat: no-repeat;
  }
}

.main-holder {
  padding-top: 100px;
}

.main-footer-holder {
  padding: 40px 0px 0px;
  margin-top: 30px;
}

.item-detalhado {
  @extend %area-de-utilizacao;
  width: 100%;
  margin: 0 auto;
  position: relative;
  padding-top: 30px;
  margin-bottom: 100px;
  min-height: 400px;

  ::-webkit-scrollbar-thumb {
    background: #f4f4f4 !important;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: $cor_cinza_medium !important;
  }

  & .nome-do-aparelho {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    border-left: 1px solid white;
    padding-left: 30px;
    margin-left: 5px;
    height: 61px;
    // padding-bottom: 9px;

    & span {
      font-family: 'VivoType';
      font-size: 10px;
      font-weight: 700;
      color: $cor_roxo;
      background: $cor_amarelo;
      padding: 0 20px;
      border-radius: 40px;
      margin: 0px;
      margin-bottom: -3px;
      margin-right: 10px;
    }

    & h1 {
      font-family: 'VivoType';
      font-size: 32px;
      font-weight: 100;
      color: white;
      text-transform: uppercase;
      margin: 0px;
      @media (max-width: 650px) {
        color: #4E4E4E;
      }
    }

    & strong {
      font-family: 'VivoType';
      font-size: 25px;
    }
  }

  & .conteudo-principal {
    width: 100%;
    margin: 0 0 60px 5px;
    padding: 70px 0 0px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    border-left: 1px solid $cor_roxo;

    @media (max-width: 650px) {
      border-left: 0;
    }

    & .imagem-destaque {
      width: 30%;
      min-width: 0;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      align-self: center;
      position: relative;

      @media (max-width: 650px) {
        width:100%;
        margin-bottom: 20px;
      }


      /* & img {
        user-select: none;
        object-fit: contain;
        max-height: 300px;
        width: auto;
      } */

      & span {
        // display: none !important;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        padding-top: 20px;

        & .alerta {
          width: 24px;
          height: 24px;
        }

        & p {
          margin: 0px;
          margin-left: 5px;
          max-width: 60%;
          font-size: 10px;
          font-style: italic;
          color: $cor_cinza_dark;
          line-height: 1.2em;
          font-weight: 600;
        }
      }
    }

    & > .planos {
      width: 70%;
      display: flex;
      flex-direction: column;
      align-self: flex-start;


      @media (max-width: 650px) {
        width:100%;
      }

      & > ul.selecione-planos {
        list-style: none;
        margin: 0;
        padding: 0;
        display: flex;
        flex: 1;
        width: 100%;
        &:after {
          content: '';
          clear: both;
        }
        & li {
          flex: 0 1 100%;
          box-sizing: border-box;
          height: 50px;
          & label {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: 100%;
            font-family: 'VivoTypeBold', sans-serif;
            font-size: 14px;
            line-height: 15px;
            font-weight: bold;
            border: 0;
            background: #f8f8f8;
            color: #7d7d7d;
            cursor: pointer;
            user-select: none;
            transition: 0.3s all ease-in-out;
            @media (max-width: 650px) {
              font-size: 10px;
            }
          }

          & input[type='radio'] {
            display: none;
            &:checked + label {
              background: #660099;
              color: #fff;
              padding: 0px 5px;
            }
          }
        }
      }

      & > .busca-planos {
        position: relative;
        width: 100%;
        height: 60px;
        background: #f7f7f7;
        box-shadow: inset 0px 0px 10px rgba(0, 0, 0, 0.03);
        border-radius: 0px 0px 5px 5px;

        & input[type='text'] {
          background: transparent;
          position: absolute;
          width: 85%;
          margin: 0;
          padding: 0 20px;
          border: none;
          outline: 0;
          height: 100%;
          font-size: 14px;
          line-height: 19px;
          color: #7d7d7d;
          &::placeholder {
            color: lighten(#7d7d7d, 20%);
          }
        }

        & > img {
          position: absolute;
          right: 20px;
          top: 22px;
        }
      }

      // Mesmo recuo do campo de busca e das linhas da lista.
      & > .bloco-parcelamento {
        padding: 0 20px;
        margin: 18px 0 4px;
      }

      & .foco {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        padding: 0px;
        margin: 0px;

        & li {
          display: flex;
          flex-direction: column;
          align-items: center;
          position: relative;
          margin-right: 30px;

          & span {
            color: $cor_amarelo;
            font-size: 14px;
            font-family: 'VivoType';
            font-weight: bold;
            text-transform: uppercase;
            position: absolute;
            top: 0;
            left: 50%;
            margin-top: -20px;
            transform: translate(-50%, 0);
          }

          & > button {
            border: 1px solid #f4f4f4;
            outline: 0;
            font-size: 20px;
            margin: 0px;
            color: $cor_roxo;
            background: #f4f4f4;
            padding: 14px;
            border-radius: 25px;
            transition: all 0.3s ease-in-out;
            &:hover {
              background: darken(#f4f4f4, 10%);
              border-color: $cor_amarelo;
            }
          }

          & p {
            font-size: 28px;
            margin: 0px;
            color: $cor_roxo;
            background: #f4f4f4;
            padding: 7px 14px;
            border-radius: 100px;
          }

          & .destaque {
            background: $cor_amarelo;
          }

          & h4 {
            margin: 0px;
            margin-top: 5px;
            font-size: 12px;
            font-family: 'VivoType';
            font-weight: bold;
            color: $cor_cinza_dark;
          }
        }
      }

      & .lista {
        color: $cor_cinza_dark;
        margin-top: 40px;

        & nav {
          width: 100%;
          border-bottom: 1px solid #f4f4f4;
          display: flex;
          justify-content: space-between;
          align-items: flex-end;
          padding-bottom: 8px;
          gap: 16px;
          overflow-y: hidden;
          scrollbar-gutter: stable;

          & .botoes {
            & button {
              background: #f4f4f4;
              font-size: 14px;
              color: $cor_cinza;
              width: 120px;
              font-family: 'VivoType';
              font-weight: bold;
              margin: 0px;
              padding: 0px;
              border-radius: 5px 5px 0 0;
              border: 0px;
              outline: none;
              height: 24px;
            }

            & .ativo {
              background: $cor_roxo;
              color: white;
            }
          }

          & .labels {
              // Mesmo recuo das linhas, para o titulo cair sobre o valor.
              padding-right: 30px;
              width: 200px;
              display: flex;
              flex: none;

              & span {
                text-align: right;
                width: 100px;
                font-size: 14px;
                color: $cor_cinza_dark;
                font-family: 'VivoType';
                font-weight: bold;
              }

              & :last-child {
                color: $cor_vivo_verde;
              }

              & .renova {
                color: $cor_vivo_verde;
              }

              & .outlet {
                color: $cor_roxo;
              }

              &.com-outlet {
                width: 300px;
              }
          }

          & .labels-vitrine {
            padding-right: 30px;
            width: 200px;
            display: flex;
            flex: none;

            & span {
              // Ocupa a coluna inteira: e o alinhamento a direita que casa com
              // o valor da linha, nao uma margem chutada.
              text-align: right;
              width: 100%;
              font-size: 14px;
              color: $cor_cinza_dark;
              font-family: 'VivoType';
              font-weight: bold;
            }
          }
        }

        & > .list-planos {
          width: 100%;
          height: auto;
          & .title {
            background: transparent;
            padding: 15px 25px;
            font-weight: bold;
            font-size: 14px;
            font-family: 'VivoTypeBold', sans-serif;
            line-height: 20px;
            margin: 0;
          }

          & > ul {
            // Rola so quando precisa e reserva a calha: com overflow-y scroll
            // fixo a barra empurrava as linhas para fora do eixo do cabecalho.
            overflow-y: auto;
            scrollbar-gutter: stable;
            width: 100%;
            margin: 0px;
            padding: 0px;
            @media (min-width: 650px) {
              max-height: 320px;
            }

            & li {
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              align-items: center;
              font-size: 13px;
              @media (max-width: 500px) {
                font-size: 10px;
              }
               @media (max-width: 330px) {
                font-size: 8px;
              }
              font-family: 'OpenSans';
              font-weight: 600;
              color: $cor_cinza_dark;

              & span {
                padding: 5px 25px;
                font-size: 11px;
                color: #7d7d7d;
                letter-spacing: 1.13px;
              }

              & p {
                margin: 0px;
                padding: 11px 0;
                line-height: 1.35;
              }

              & .descricao {
                // Ocupa a sobra e quebra em duas linhas quando o nome e longo,
                // em vez de espremer a coluna de valores.
                flex: 1;
                min-width: 0;
                padding-left: 20px;
                padding-right: 16px;
              }

              & div {
                display: flex;
                flex-direction: row;
                align-items: center;
                flex: none;
                padding-right: 30px;
                width: 200px;

                & .preco {
                  width: 100px;
                  text-align: right;
                  font-weight: bold;
                }

                & .renova {
                  width: 100px;
                  text-align: right;
                  color: $cor_vivo_verde;
                  font-weight: bold;
                }

                & .preco-vitrine {
                  width: 100px;
                  text-align: right;
                  font-weight: bold;
                }

                & .renova {
                  width: 92px;
                  text-align: center;
                  color: $cor_vivo_verde;
                  font-weight: bold;
                }
              }

              & .valores {
                display: flex;
                flex-direction: row;
                align-items: center;
                padding-right: 30px;
                width: 200px;

                & .preco-vitrine {
                  width: 100px;
                  text-align: right;
                  font-weight: bold;
                }

                & .preco {
                  width: 100px;
                  text-align: right;
                  font-weight: bold;
                }

                & .renova {
                  width: 100px;
                  text-align: right;
                  color: $cor_vivo_verde;
                  font-weight: bold;
                }

                & .outlet {
                  width: 100px;
                  text-align: right;
                  color: $cor_roxo;
                  font-weight: bold;
                }

                &.com-outlet {
                  width: 300px;
                }
              }

            }

            & li:first-child {
              margin-top: 5px;
            }

            & li:last-child {
              margin-bottom: 5px;
            }

            & li:nth-child(even) {
              background: #f4f4f4;
            }
          }
        }
      }

      & .linha-inputs {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;

        & button {
          all: unset;
          border: 1px solid $cor_vivo_verde;
          background: $cor_vivo_verde;
          color: white;
          font-family: 'VivoType';
          font-weight: bold;
          font-size: 18px;
          width: 100%;
          flex: 0.29;
          margin: 0px;
          padding: 0px;
          text-align: center;
          height: 60px;
          border-radius: 5px;
          box-shadow: 0px 10px 20px rgba(46, 205, 80, 0.5);
          transition: all 0.15s ease-in-out;

          &:hover {
            transform: scale(1.05);
            margin-top: -10px;
            box-shadow: 0px 20px 40px rgba(46, 205, 80, 0.25);
          }

          &:disabled {
            background: $cor_cinza_medium;
            border-color: $cor_cinza_medium;
            color: $cor_cinza;
            box-shadow: none;

            &:hover {
              transform: none;
              margin-top: 0;
              box-shadow: none;
            }
          }
        }
      }

      & .linha {
        padding: 10px 0;
      }

      & .head {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-start;
        z-index: 1;
        width: 100%;

        & h3 {
          font-family: 'VivoType';
          font-weight: bold;
          font-size: 28px;
          text-transform: uppercase;
          padding-top: 5px;
          margin: 0px;
          color: $cor_roxo;
          flex: 0.5;
        }

        & .pdv {
          flex: 0.45;

          & h6 {
            font-style: italic;
            font-size: 11px;
            font-weight: 400;
            color: $cor_cinza_dark;
            margin: 5px 0 0;
            text-align: right;
          }
        }
      }

      & .cadastro {
        margin-top: 20px;
      }
    }

    & > .acessorios {
      // Era altura fixa: com o seletor de forma de pagamento o conteudo
      // estourava os 300px e passava por cima do bloco de baixo.
      min-height: 300px;
      width: 70%;
      display: flex;
      flex-direction: column;
      justify-content: center;

      // O restante do bloco e centralizado; sem isso o seletor ficava colado
      // na esquerda, fora do eixo do preco.
      & .bloco-parcelamento {
        align-self: center;
        max-width: 380px;

        & .aviso-pix {
          text-align: center;
        }

        & .filtro-parcelamento {
          justify-content: center;
        }
      }

      & .preco {
        align-items: center;
        text-align: center;
        display: flex;
        justify-content: center;

        & p {
          background: #ff9900;
          width: auto;
          padding: 30px;
          border-radius: 10px;
          font-family: OpenSans;
          font-style: normal;
          font-weight: normal;
          font-size: 42px;
          line-height: 57px;
          color: #660099;
          transition: 0.3s all ease-in-out;
          & span {
            margin-right: 10px;
          }

          &:hover {
            background: lighten(#ff9900, 10%);
            color: lighten(#660099, 10%);
          }
        }
      }

    }
  }

  & .ficha-tecnica {
    background: #f4f4f4;
    padding: 30px 50px 40px;
    border-radius: 15px;
    position: relative;

    & h2 {
      font-size: 22px;
      font-family: 'VivoType';
      font-weight: bold;
      color: $cor_roxo;
    }

    & ul {
      width: 100%;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      align-items: center;
      justify-content: space-between;
      margin: 20px 0 0;
      padding: 0px;

      & li {
        margin: 4px 0;
        width: 31%;
        @media (max-width: 650px) {
          width: 50%;
        }
        @media (max-width: 380px) {
          width: 100%;
        }
        & p {
          font-size: 15px;
          color: $cor_cinza;
          margin: 0px;
          @media (max-width: 450px) {
            font-size: 11px;
          }
        }

        & strong {
          font-size: 16px;
          font-family: 'VivoType';
          font-weight: bold;
          @media (max-width: 450px) {
            font-size: 12px;
          }
        }
      }
    }

    & span {
      width: calc(100% - 100px);
      position: absolute;
      bottom: 0;
      background: $cor_cinza_medium;
      height: 4px;
      border-radius: 4px 4px 0 0;
    }
  }

  & .similares {
    margin: 70px 0;

    & h2 {
      font-size: 22px;
      font-family: 'VivoType';
      font-weight: bold;
      color: $cor_roxo;
      text-align: center;
    }
    .botao-nav {
      display: flex;
      font-size: 40px;
      margin-top: 70px;
    }
    & .relacionados {
      display: flex;
      flex: 0.33;
      flex-direction: row;
      align-items: flex-start;
      justify-content: space-between;
      align-self: flex-start;
      margin: 0 auto;
      margin-top: 50px;
      max-width: 980px;
      height: auto;
      padding: 0;

      .celular {
        width: 230px;
      }

      & a {
        user-select: none;
        text-decoration: none;
        display: flex;
        flex-direction: column;
        align-items: stretch;
        justify-content: center;
        margin: 0px;
        margin-bottom: 50px;
        // height: 300px;
        transition: all 0.2s ease-in-out;
        color: $cor_cinza_darkest;

        & .foto {
          display: flex;
          align-items: center;
          justify-content: center;

          & img {
            height: 180px;
            object-fit: contain;
            width: auto;
          }
        }

        & .informacoes {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          & h3 {
            font-family: 'VivoType';
            text-align: center;
            color: $cor_cinza_dark;
            font-weight: 300;
            font-size: 16px;
            margin: 10px 0 0;
            max-width: 90%;
            line-height: 1em;
            text-transform: uppercase;

            & strong {
              font-family: 'VivoType';
            }
          }

          & p {
            color: $cor_cinza_dark;
            font-size: 24px;
            margin: 0px;
            font-weight: 100;

            & strong {
              font-weight: 700;
            }
          }
        }

        &:hover {
          transform: scale(1.1);
          margin-top: -10px;
          // perspective: 100px;
          // transform: rotateY(360deg);
          // transform-style: preserve-3d
        }

        // &::after {
        //   content: "";
        //   flex: 0 0 380px;
        // }
      }

      & .com-filtro {
        //width: 25%;
      }

      & .sem-filtro {
        width: 20%;
      }
    }
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active em versões anteriores a 2.1.8 */ {
  opacity: 0;
}

.cx-celulares {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.bloco-parcelamento {
  margin-top: 12px;
  margin-bottom: 12px;
}

.filtro-parcelamento {
  display: flex;
  align-items: center;
  gap: 10px;

  label {
    font-size: 13px;
    color: #4e4e4e;
  }

  select {
    height: 32px;
    padding: 0 8px;
    border: 1px solid #d6d6d6;
    border-radius: 4px;
    background: #fff;
    font-size: 13px;
    color: #4e4e4e;
    cursor: pointer;
  }
}

.selo-outlet {
  display: block;
  align-self: center;
  width: fit-content;
  max-width: 100%;
  margin: 12px auto 0;
  padding: 4px 18px;
  border-radius: 40px;
  font-family: 'VivoType';
  font-size: 13px;
  font-weight: 700;
  text-align: center;
  color: $cor_roxo;
  background: $cor_amarelo;
}

.aviso-pix {
  margin: 0 0 6px;
  font-size: 12px;
  font-style: italic;
  color: #4e4e4e;
}
</style>
